<div class="container d-flex flex-row gap-3">
    <div class="flex justify-content-center">
        <select class="form-select" [disabled]="!pagination.page" (change)="selectItems()" [(ngModel)]="pagination.itemsPage" aria-label="Default select example">
            <option *ngFor="let page of itemsPage" [value]="page">{{page}}</option>
        </select>
    </div>

    <div class="row">
        <ngb-pagination [collectionSize]="pagination.pages * 10" 
            [(page)]="pagination.page" 
            [boundaryLinks]="true"
            (pageChange)="selectPage()">
            <ng-template ngbPaginationPages let-page let-pages="pages">
                <li class="ngb-custom-pages-item" *ngIf="pages.length > 0">
                    <div class="mb-3 d-flex flex-nowrap px-2">
                        <label id="paginationInputLabel" for="paginationInput"
                            class="col-form-label me-2 ms-1">Página</label>
                        <input #i 
                            type="text" 
                            inputmode="numeric" 
                            pattern="[1-9]*"
                            class="form-control custom-pages-input" 
                            id="paginationInput" 
                            [value]="page"
                            (keyup.enter)="selectPage(i.value)" 
                            (change)="selectPage(i.value)"
                            (input)="formatInput($any($event).target)"
                            aria-labelledby="paginationInputLabel paginationDescription" style="width: 3.5rem" />
                        <span id="paginationDescription" class="col-form-label text-nowrap px-2"> de
                            {{pages.length}}</span>
                    </div>
                </li>
            </ng-template>
        </ngb-pagination>
    </div>
</div>